import { render, staticRenderFns } from "./DriverLayout.vue?vue&type=template&id=5f334f93&scoped=true"
import script from "./DriverLayout.vue?vue&type=script&lang=js"
export * from "./DriverLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f334f93",
  null
  
)

export default component.exports